function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 336 138",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M294.84,61.408c-12.927,-4.867 -22.126,-17.343 -22.126,-31.971c0,-4.583 0.909,-8.953 2.547,-12.946c-9.906,-9.706 -23.055,-15.462 -38.405,-15.462c-31.51,-0 -53.852,24.276 -57.965,57.001c-8.041,-5.737 -18.583,-8.685 -30.355,-8.685c-3.257,-0 -6.182,0.261 -8.84,0.72l-11.099,24.726c4.306,-0.615 10.191,-1.341 14.198,-1.372c0.211,-0.002 0.415,-0 0.615,0.002c0.409,0.005 0.792,0.019 1.149,0.041c13.396,0.545 21.461,8.423 21.461,19.124l-0,0.376c-0,11.28 -8.272,19.364 -22.561,19.364c-14.288,-0 -22.936,-8.46 -22.936,-19.552c-0,0 -1.237,-19.369 0.767,-34.979c-0.005,0.003 -0.01,0.006 -0.015,0.01c1.88,-17.296 10.152,-30.457 26.508,-30.457c9.81,0 16.351,2.989 23.577,8.095l11.448,-25c-9.512,-6.047 -19.817,-9.416 -34.085,-9.416c-38.369,-0 -56.829,29.763 -57.676,68.974c-6.769,-7.571 -16.887,-11.41 -27.137,-13.137l33.276,-31.772l-0,-21.809l-79.113,0l-9.812,24.816l51.701,-0l-31.396,31.585l4.512,18.425l12.032,-0c16.168,-0 25.756,6.016 25.756,16.731l-0,0.376c-0,9.776 -7.708,15.98 -18.612,15.98c-13.348,-0 -22.749,-5.64 -31.773,-15.792l-19.928,18.988c11.28,13.348 27.637,22.748 51.325,22.748c23.166,-0 39.284,-11.383 45.039,-28.393c2.544,5.825 5.828,10.427 9.694,14.293c9.212,9.212 20.869,14.1 37.977,14.1c20.583,-0 37.555,-9.658 45.441,-25.107c10.159,15.427 26.328,25.108 46.451,25.108c35.156,0 58.657,-29.893 58.657,-68.057l-0,-0.377c-0,-2.47 -0.104,-4.904 -0.297,-7.299Zm-29.408,8.053c-0,23.877 -11.092,41.549 -28.576,41.549c-17.484,-0 -28.953,-17.859 -28.953,-41.924l-0,-0.377c-0,-24.064 11.28,-41.548 28.577,-41.548c17.296,-0 28.952,18.048 28.952,41.925l-0,0.375Z",
    style: {
      fill: "#6057a6",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M323.168,5.967c-4.623,-3.218 -10.238,-5.108 -16.298,-5.108c-0.818,-0 -1.626,0.042 -2.426,0.11l18.724,18.828l0,-13.83Z",
    style: {
      fill: "#6057a6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.799,1.317c-6.688,1.199 -12.569,4.72 -16.775,9.706l26.555,0.074l-9.78,-9.78Z",
    style: {
      fill: "#6057a6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.401,13.139c-3.216,4.624 -5.107,10.239 -5.107,16.298c0,0.816 0.043,1.625 0.109,2.425l18.827,-18.722l-13.829,-0.001Z",
    style: {
      fill: "#6057a6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.753,34.508c1.197,6.689 4.719,12.569 9.704,16.775l0.072,-26.553l-9.776,9.778Z",
    style: {
      fill: "#6057a6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.574,52.905c4.623,3.217 10.238,5.108 16.296,5.108c0.819,-0 1.627,-0.043 2.428,-0.11l-18.723,-18.827l-0.001,13.829Z",
    style: {
      fill: "#6057a6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.942,57.556c6.689,-1.199 12.568,-4.72 16.776,-9.706l-26.556,-0.074l9.78,9.78Z",
    style: {
      fill: "#6057a6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.338,27.011l-18.827,18.723l13.83,-0c3.217,-4.624 5.107,-10.239 5.107,-16.297c-0,-0.818 -0.042,-1.626 -0.11,-2.426Z",
    style: {
      fill: "#6057a6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.99,24.365c-1.198,-6.688 -4.72,-12.569 -9.705,-16.775l-0.074,26.554l9.779,-9.779Z",
    style: {
      fill: "#6057a6",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8ac1c57ad5d0d21de5bfc2d36c076878.svg";
export { ForwardRef as ReactComponent };